module.exports = __webpack_public_path__ + "logo-wikinggruppen.d87d9692c5be403264ee7857111a1aa1.svg";